import { Route } from '@angular/router';

export const bobs27StatisticsRoutes: Route[] = [
    {
        path: 'bobs-27/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/bobs-27-statistics-details/bobs-27-statistics-details.component').then(
                (c) => c.Bobs27StatisticsDetailsComponent
            ),
    },
    {
        path: 'bobs-27/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/bobs-27-statistics-games/bobs-27-statistics-games.component').then(
                (c) => c.Bobs27StatisticsGamesComponent
            ),
    },
    {
        path: 'bobs-27/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/bobs-27-statistics-games-details/bobs-27-statistics-games-details.component').then(
                (c) => c.Bobs27StatisticsGamesDetailsComponent
            ),
    },
];
